/* GENERATED by scripts/fetch-lpc.mjs — do not edit by hand.
   (The type annotation below is hand-written; the generator emits the data.) */

/** A head sheet: carries the neck, and names the face-sheet directory. */
export interface WardrobeHead {
  id: string;
  name: string;
  dir: string;
  faceDir: string;
  zPos: number;
}

/** An expression sheet. Has no directory of its own — `faceDir` locates it. */
export interface WardrobeFace {
  id: string;
  name: string;
  zPos: number;
}

/** Hair, and every clothing item. `zPos` is paint order, not a constant per
    slot: boots sit over trousers, shoes under them. */
export interface WardrobeItem {
  id: string;
  name: string;
  dir: string;
  variants?: string[] | null;
  zPos: number;
}

interface Wardrobe {
  heads: WardrobeHead[];
  faces: WardrobeFace[];
  hair: WardrobeItem[];
  torso: WardrobeItem[];
  legs: WardrobeItem[];
  feet: WardrobeItem[];
  /** head id → body sheet directory. */
  body: Record<string, string>;
}

export const WARDROBE: Wardrobe = {
  "heads": [
    {
      "id": "male",
      "name": "Human Male",
      "dir": "head/heads/human/male/",
      "faceDir": "male",
      "zPos": 100
    },
    {
      "id": "female",
      "name": "Human Female",
      "dir": "head/heads/human/female/",
      "faceDir": "female",
      "zPos": 100
    }
  ],
  "faces": [
    {
      "id": "neutral",
      "name": "Neutral",
      "zPos": 101
    },
    {
      "id": "happy",
      "name": "Happy",
      "zPos": 101
    },
    {
      "id": "sad",
      "name": "Sad",
      "zPos": 101
    },
    {
      "id": "anger",
      "name": "Angry",
      "zPos": 101
    },
    {
      "id": "closed",
      "name": "Closed Eyes",
      "zPos": 101
    },
    {
      "id": "shock",
      "name": "Shock",
      "zPos": 101
    },
    {
      "id": "blush",
      "name": "Blush",
      "zPos": 101
    }
  ],
  "hair": [
    {
      "id": "afro",
      "name": "Afro",
      "dir": "hair/afro/adult/",
      "zPos": 120
    },
    {
      "id": "cornrows",
      "name": "Cornrows",
      "dir": "hair/cornrows/adult/",
      "zPos": 120
    },
    {
      "id": "dreadlocks_long",
      "name": "Dreadlocks long",
      "dir": "hair/dreadlocks_long/adult/",
      "zPos": 120
    },
    {
      "id": "dreadlocks_short",
      "name": "Dreadlocks short",
      "dir": "hair/dreadlocks_short/adult/",
      "zPos": 120
    },
    {
      "id": "flat_top_fade",
      "name": "Flat top fade",
      "dir": "hair/flat_top_fade/adult/",
      "zPos": 120
    },
    {
      "id": "natural",
      "name": "Natural",
      "dir": "hair/natural/adult/",
      "zPos": 120
    },
    {
      "id": "twists_fade",
      "name": "Twists fade",
      "dir": "hair/twists_fade/adult/",
      "zPos": 120
    },
    {
      "id": "buzzcut",
      "name": "Buzzcut",
      "dir": "hair/buzzcut/adult/",
      "zPos": 120
    },
    {
      "id": "balding",
      "name": "Balding",
      "dir": "hair/balding/adult/",
      "zPos": 120
    },
    {
      "id": "bob",
      "name": "Bob",
      "dir": "hair/bob/adult/",
      "zPos": 120
    },
    {
      "id": "idol",
      "name": "Idol",
      "dir": "hair/idol/adult/",
      "zPos": 120
    },
    {
      "id": "plain",
      "name": "Plain",
      "dir": "hair/plain/adult/",
      "zPos": 120
    },
    {
      "id": "page",
      "name": "Page",
      "dir": "hair/page/adult/",
      "zPos": 120
    },
    {
      "id": "long_straight",
      "name": "Long straight",
      "dir": "hair/long_straight/adult/",
      "zPos": 120
    },
    {
      "id": "spiked",
      "name": "Spiked",
      "dir": "hair/spiked/adult/",
      "zPos": 120
    }
  ],
  "torso": [
    {
      "id": "clothes-longsleeve-longsleeves2-male",
      "name": "Longsleeves 2 Overlay",
      "dir": "torso/clothes/longsleeve/longsleeves2/male/",
      "variants": null,
      "zPos": 36
    },
    {
      "id": "clothes-shortsleeve-shortsleeves2-male",
      "name": "Shortsleeves 2 Overlay",
      "dir": "torso/clothes/shortsleeve/shortsleeves2/male/",
      "variants": null,
      "zPos": 36
    }
  ],
  "legs": [
    {
      "id": "pants-male",
      "name": "Pants",
      "dir": "legs/pants/male/",
      "variants": null,
      "zPos": 20
    },
    {
      "id": "pants2-male",
      "name": "Long Pants",
      "dir": "legs/pants2/male/",
      "variants": null,
      "zPos": 20
    },
    {
      "id": "formal-male",
      "name": "Formal Pants",
      "dir": "legs/formal/male/",
      "variants": null,
      "zPos": 20
    },
    {
      "id": "shorts-shorts-male",
      "name": "Shorts",
      "dir": "legs/shorts/shorts/male/",
      "variants": null,
      "zPos": 20
    }
  ],
  "feet": [
    {
      "id": "shoes-revised-male",
      "name": "Revised Shoes",
      "dir": "feet/shoes/revised/male/",
      "variants": null,
      "zPos": 15
    },
    {
      "id": "boots-revised-male",
      "name": "Revised Boots",
      "dir": "feet/boots/revised/male/",
      "variants": null,
      "zPos": 25
    }
  ],
  "body": {
    "male": "body/bodies/male/",
    "female": "body/bodies/female/"
  }
};
